import i18n from '../i18n';

export const t = i18n.t;
